var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
import muiTypography from '@customink/design-tokens/build/ci_light/js/typography.mui';
var themeOptions = function (theme) { return ({
    components: {
        MuiAlert: {
            defaultProps: {},
            styleOverrides: {
                root: {
                    marginBottom: theme.spacing(0.25),
                    '&.MuiAlert-outlinedError': {
                        backgroundColor: '#FDF4F4',
                        borderColor: '#DA1E28',
                        '.MuiAlert-icon': {
                            color: '#DA1E28',
                        },
                    },
                    '&.MuiAlert-outlinedSuccess': {
                        backgroundColor: '#F4F9F5',
                        borderColor: '#198038',
                        '.MuiAlert-icon': {
                            color: '#198038',
                        },
                    },
                    '&.MuiAlert-outlinedWarning': {
                        backgroundColor: '#FEF9E8',
                        borderColor: '#F1C21B',
                        '.MuiAlert-icon': {
                            color: '#F1C21B',
                        },
                    },
                    '&.MuiAlert-outlinedInfo': {
                        backgroundColor: '#F2F6FD',
                        borderColor: '#0043CE',
                        '.MuiAlert-icon': {
                            color: '#0043CE',
                        },
                    },
                    '.MuiAlert-message': __assign(__assign({}, muiTypography.paragraphSmall), { color: designTokens.color.shade.black.value, padding: 0, marginTop: theme.spacing(1.25), marginBottom: theme.spacing(0.75) }),
                    '.MuiAlertTitle-root': __assign(__assign({}, muiTypography.uiTextDefault), { color: designTokens.color.shade.black.value, margin: 0, marginBottom: theme.spacing(0.5) }),
                    '.MuiAlert-icon': {
                        padding: 0,
                        marginTop: theme.spacing(1),
                        marginBottom: theme.spacing(1),
                        svg: {
                            width: theme.spacing(3),
                            height: theme.spacing(3),
                        },
                    },
                    '.MuiAlert-action': {
                        paddingTop: theme.spacing(0.25),
                        '.MuiIconButton-root': {
                            width: theme.spacing(4),
                            height: theme.spacing(4),
                            '.MuiSvgIcon-root': {
                                color: designTokens.color.gray.obsidian.value,
                            },
                        },
                    },
                },
            },
        },
    },
}); };
export default themeOptions;
//# sourceMappingURL=alertTheme.js.map